import Experience from "../Experience";
import Environment from "./Environment";
import Floor from "./Floor";
import Fox from "./Fox";
// import SkyFish from "./SkyFish";
// import SkyFish2 from "./SkyFish2";
import Train from "./Train";
import Game from "./Game";
import TrackManager from "./TrackManager";
import Pickups from "./Pickups";
import Obstacles, { BOMB_SCORE } from "./Obstacles";
import Projectiles from "./Projectiles";

export default class World {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;

    this.game = new Game();

    //wait for reesources
    this.resources.on("ready", () => {
      //setup
      // this.floor = new Floor();
      // this.fox = new Fox();
      this.train = new Train();
      this.trackManager = new TrackManager();
      this.pickups = new Pickups();
      this.obstacles = new Obstacles();
      this.projectiles = new Projectiles();
      // this.skyFish = new SkyFish2();
      this.environment = new Environment();
    });
  }

  update() {
    const delta = Math.min(this.time.delta * 0.001, 0.05); // clamp big spikes (tab refocus)

    if (this.game) this.game.update();

    const playing = this.game && this.game.isPlaying();
    if (this.trackManager && playing) this.trackManager.update(delta);
    const speed = this.trackManager ? this.trackManager.speed : 0;

    if (this.pickups && playing) {
      const collected = this.pickups.update(delta, speed);
      if (collected > 0) this.game.addScore(collected);
    }
    if (this.obstacles && playing) {
      const trainHit = this.obstacles.update(delta, speed);
      if (trainHit) {
        this.experience.camera.shake(1.6, 3.0);
        this.game.die("Boom");
      }
    }
    if (this.projectiles && playing) {
      const hits = this.projectiles.update(delta, speed);
      if (hits > 0) {
        this.game.addScore(hits * BOMB_SCORE);
        this.experience.camera.shake(0.5, 5);
      }
    }

    if (this.train) this.train.update();
    if (this.skyFish) this.skyFish.update();
  }
}
